// Checkout renders light unless the originating merchant app locks a theme with
// `?theme=dark|light` (Doodles passes light, MakerChip passes its active theme).
// The surface never follows the device preference: the merchant app the customer
// came from — not their OS — decides what "consistent" looks like, and an
// unthemed entry (email link, direct open) stays light.
//
// Like the access token, the lock has to survive the Stripe
// round-trip: it arrives on the Review&Pay URL (`/o/:token?theme=…`) but the
// success/cancelled URLs minted by /api carry no query. We stash it keyed by
// order id, mirroring `tinkr.checkout.token.{orderId}`.
//
// sessionStorage (not localStorage): per-checkout presentation state scoped to
// the tab, so one merchant's theme never leaks into another merchant's later
// checkout in a different tab.

export type CheckoutTheme = "light" | "dark";

const PREFIX = "tinkr.checkout.theme.";

export function themeFromSearch(search: string): CheckoutTheme | null {
  const value = new URLSearchParams(search).get("theme");
  return value === "light" || value === "dark" ? value : null;
}

export function rememberThemeForOrder(orderId: string, theme: CheckoutTheme): void {
  try {
    window.sessionStorage.setItem(PREFIX + orderId, theme);
  } catch {
    // Storage unavailable (private mode); the post-Stripe screens fall back to
    // the light default. Silent, non-fatal.
  }
}

export function recallThemeForOrder(orderId: string): CheckoutTheme | null {
  try {
    const value = window.sessionStorage.getItem(PREFIX + orderId);
    return value === "light" || value === "dark" ? value : null;
  } catch {
    return null;
  }
}
